export const MINIMIZED_SIZE = { width: 480, height: 366 };
export const MAXIMIZED_SIZE = { width: 1100, height: 720 };
export const MINIMIZED_POSITION = { right: 20, bottom: 20 };
export const LOCALSTORAGE_KEY = 'cameraStreamPopupWindow';
export const HEADER_HEIGHT = 96;
